// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mmC0V","controls":"styles_controls__2TL8k","charLimit":"styles_charLimit__Jw0cW","input":"styles_input__1ktLA","send":"styles_send__2TtEW"};